import { ColumnTable } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../locales/translations';
import { CoursePrerequisite } from '../types/details';

export const useColumnsPrerequisites = () => {
  const { t } = useTranslation(TranslationsKeys.COURSES_DETAILS);

  const columns: ColumnTable<CoursePrerequisite>[] = useMemo(() => {
    return [
      {
        columnName: 'shortening',
        width: '30%',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: t(`prerequisiteShortening`),
      },
      {
        columnName: 'name',
        width: '40%',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: t(`prerequisiteName`),
      },
      {
        columnName: 'credits',
        width: '15%',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: t(`prerequisiteCredits`),
      },
    ];
  }, [t]);

  return { columns };
};
